<template>
  <sl-page>
    <div class='page-filter'>
      <Row :gutter="12">
        <Col span="6" :lg="4" :md="6" :sm="12" :xs="24" class="margin-bottom">
          <Input v-model="params.contractNo" placeholder="合同编号"></Input>
        </Col>
        <Col span="6" :lg="4" :md="6" :sm="12" :xs="24" class="margin-bottom">
          <Input v-model="params.orderNo" placeholder="订单编号"></Input>
        </Col>
        <Col span="6" :lg="4" :md="6" :sm="12" :xs="24" class="margin-bottom">
          <Input v-model="params.partyBName" placeholder="乙方名称"></Input>
        </Col>
        <Col span="6" :lg="4" :md="6" :sm="12" :xs="24" class="margin-bottom">
          <Input v-model="params.creator" placeholder="创建人"></Input>
        </Col>
        <Col span="24" :lg="8" :md="24" :sm="24" :xs="24" class="page-action">
          <div>
            <Button type="primary" icon="ios-search" @click="list()">搜索</Button>
            <Button icon="ios-reset" @click="reset()">清空</Button>
          </div>
          <!-- <div>
            <Button :disabled="removeDisable" type="error" icon="md-trash" @click="abandonBatch()">废弃</Button>
          </div> -->
        </Col>
      </Row>  
    </div>
    <div class="pg-bd">
      <sl-table ref="table" :loading="loading" :page="page" :columns="columns" :data="data" @on-selection-change="handleSelect" @on-update="handleChange"></sl-table>
    </div>

    <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
      <contract-item ref="item" @on-update="handleUpdate"></contract-item>
    </sl-side-panel>

  </sl-page>
</template>
<script>
import contractItem from './detail'
import listComponent from '@/util/proto/listComponent'

const columns_ = [
  /*{
    type: 'selection',
    width: 60,
    align: 'center'
  },*/
  {
    title: '合同编号',
    key: 'contractNo'
  },
  {
    title:'订单编号',
    key:'orderNo',
  },
  {
    title: '乙方名称',
    key: 'partyBName'
  },
  {
    title: '合同类型',
    key: 'contractType'
  },
  {
    title: '合同状态',
    key: 'state'
  },
  {
    title: '文件名称',
    key: 'name'
  },
  {
    title: '创建人',
    key: 'creator'
  },
  {
    title: '创建时间',
    key: 'createDatetimeText'
  },
  
]

export default {
  extends: listComponent,

  data() {
    return {
      columns: [
        ...columns_,
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.view(params)
                  }
                }
              }, '查看'),
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.download(params)
                  }
                }
              }, '下载'),
/*              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.abandon(params)
                  }
                }
              }, '废弃')*/
            ])
          }
        }
      ],
      data: [],
      params:{
        partyBName:null,
        contractNo:null,
        orderNo:null,
        creator:null,
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total:0
      },
      loading: false,
      modalVisible:false,
      modalSkuVisible:false,
      itemTitle:'',
      selection:[]
    }
  },
  computed: {
    removeDisable(){
      return this.selection.length == 0
    }
  },
  created(){
    this.def = {...this.params}
    this.list()
  },

  methods: {

    list() {
      let params = {search:{...this.params} , pageSize:this.page.pageSize , pageNum : this.page.pageNum }
      this.loading = true
      this.$request.contracts(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list || [] , {'createDatetime':'time'})
          this.page.total = resp.data.total || 0
        }
      })
    },

    view({row}){
      this.modalVisible = true
      this.$refs['item'].init( row.id )
      this.itemTitle = `合同编号：${row.contractNo}`
    },

    abandon({row}){
      this.$ui.confirm(this.$request.goodsDelete ,  `确定废弃合同 ${row.name} ？`)(row.id).then( resp => {
        if(!resp.code){
          this.$Message.success('操作成功')
          this.selection = []
          this.list()
        }
      })
    },

    download({row}){
      this.$request.contractDownload(row.id).then(resp=>{
        this.$utils.saveFile(resp , row.name )
      })
    },

    reset(){
      this.$utils.fill(this.params , this.def)
      console.log( this.params )

      this.list()
    },

    abandonBatch(){
      let params = {ids:this.selection}
      this.$ui.confirm(this.$request.roleDeleteBatch ,  '确定废弃？')(params).then( resp => {
        if(!resp.code){
          this.$Message.success('操作成功')
          this.selection = []
          this.list()
        }
      })
    },
  

    handleUpdate(){
      this.modalVisible = false
      this.list()
    },

    handleChange( pageNum , pageSize ){
      if( this.page.pageNum != pageNum || this.page.pageSize != pageSize){
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.list()
      }
    },

    handleSelect(selection){
      this.selection = selection.map(i=>i.id)
    }
  },
  render(){

    return <sl-page>
        <div class="page-filter">
          <sl-search on-search={this.search} on-reset={this.reset}>
            <sl-search-item label="">
              <i-input v-model={this.params.contractNo} placeholder="合同编号" />
            </sl-search-item>
            <sl-search-item label="">
              <i-input v-model={this.params.orderNo} placeholder="订单编号" />
            </sl-search-item>
            <sl-search-item label="">
              <i-input v-model={this.params.partyBName} placeholder="乙方名称" />
            </sl-search-item>
            <sl-search-item label="">
              <i-input v-model={this.params.creator} placeholder="创建人" />
            </sl-search-item>
          </sl-search>
        </div>
        <div class="pg-bd">
          <sl-table show-header={true} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange}>
          </sl-table>
        </div>
      </sl-page>
  }
}

</script>